const styles = () => ({
  root: {
    backgroundColor: '#32383F',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFF',
    fontSize: 20,
    zIndex: 1000,
  },
});

export default styles;
